import { getUserToken } from '../util/UserUtil';
import { getCookieLang } from '../providers/LanguageProvider';

export const HttpOperations = {
    login: "auth",
    user: "user",

    dimension: "dimension",
    goodpractices: "goodpractices",
    block: "block",
    categories: "categories",

    groupinfo: "groupinfo",
    useranswer: "useranswer",
}

export const HttpMethod = {
    get: "GET",
    post: "POST",
    patch: "PATCH",
    delete: "DELETE",
    put: "PUT"
}

export const HttpConnection = async (operation, success, error, method = "GET", data = null, checkingAuth = false) => {
    try {
        let token = getUserToken();
        const url = new URL(`${serverUrlEndpoint}${operation}`);
        url.searchParams.set('lang', getCookieLang().language.id);
        const request = await fetch(url.toString(), {
            method: method,
            body: data === null ? null : JSON.stringify(data),
            headers: {
                'Authorization': `${token === null || checkingAuth ? '' : token}`,
                'Content-Type': 'application/json',
            }
        })

        let item = Object()

        if (!request.ok) {
            error(request.status);
        } else {
            item = await request.json();
            success(item);
        }
    } catch (e) {
        error(e.message);
    }
}

const debugMode = false;
//movil: 172.20.10.8
//wifi: 192.168.5.39

export const serverUrlEndpoint = debugMode ? "http://localhost/ambit/furncircle-api/public/api/" : "https://assessment.furncircle.eu/furncircle-api/public/api/";
export const imageURL = ""